// eslint-disable-next-line no-unused-vars
import dispatchActionForAllModules from '@/src/utils/dispatch-action-for-all-modules'
import { profileQuestions } from '@services/safehaven/ProfileQuestionnaire'

export const state = {
  questionnaire: null,
}

export const getters = {
  getQuestionnaire: (state) => {
    return state.questionnaire ? state.questionnaire : null
  },
}

export const mutations = {
  SET_QUESTIONNAIRE(state, newValue) {
    state.questionnaire = newValue
  },
}

export const actions = {
  async setQuestionnaire({ commit, state }, payload) {
    commit('SET_QUESTIONNAIRE', [])
    profileQuestions.getAllQuestions().then((response) => {
      if (response.status === 200) {
        commit('SET_QUESTIONNAIRE', response.data)
        return response.data
      }
    })
  },
}
